import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home';
import { BottonMenuComponentPageModule } from '../components/botton-menu-component/botton-menu-component.module';
import { AgmCoreModule } from '@agm/core';
import { ENV } from '../../app/environment';

@NgModule({
  declarations: [
    HomePage,
  ],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: ENV.googleMapsApiKey
    }),
    BottonMenuComponentPageModule,
    IonicPageModule.forChild(HomePage),
  ],
})
export class HomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts